import $ from 'jquery'

$(document).on('turbolinks:load', function () {
  const wrapperDiv = document.querySelectorAll(
    '[data-behaviour="tmp-billing-proposal"]'
  )[0]
  const firmId = Silverfin.currentFirmId
  if (wrapperDiv && firmId) {
    const url =
      Silverfin.Routes.tmp_billing_proposal_admin_finance_firm_billing_proposals_path(
        { firm_id: Silverfin.currentFirmId }
      )
    $.get(url).fail(function () {
      $(wrapperDiv)
        .find('.sf-level')
        .html(
          "<span class='sf-font-l'><i class='fa fa-times sf-c-danger'></i> Error, can't load preview</span>"
        )
    })
  }
})
